/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

export interface FilterDateProps {
  from: string;
  to: string;
}

export const getDateRange = (
  key: 'sixMonthsAgo' | 'oneYearAgo' | '',
  numberRange = 1
): FilterDateProps | '' => {
  const currentDate = new Date();
  const pastDate = new Date(currentDate);

  switch (key) {
    case 'sixMonthsAgo': {
      pastDate.setMonth(pastDate.getMonth() - numberRange);
      break;
    }
    case 'oneYearAgo': {
      pastDate.setFullYear(pastDate.getFullYear() - numberRange);
      break;
    }
    default:
      return '';
  }

  const result = {
    from: pastDate?.toISOString().split('T')[0],
    to: `${currentDate?.toISOString().split('T')[0]} 23:59:59`,
  };

  return result;
};

export const addYearsToList = (
  startYear: number
): { value: string; text: string }[] => {
  const result = [];
  const currentYear = new Date().getFullYear();

  for (let year = startYear; year <= currentYear - 1; year++) {
    result.push({
      value: `{"from":"${year}-01-01","to":"${year + 1}-01-01 23:59:59"}`,
      text: year.toString(),
    });
  }

  return result;
};
